/**
 * Polyfill to add support to NodeList forEach in IE
 *
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Polyfill}
 */

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
